import React from 'react';
import { CopyIcon, XIcon } from '@components-library/Icons/iconsComponents';
import { IMaster } from '@components-member/socialTrading/social.interfaces';
import { keyMap } from '@locales/lokalise/keyMap';
import actionStyles from './actions.styles.module.scss';

export const DEFAULT_RATING_PERIOD = 'Overall';
export const DEFAULT_FILTER_PERIOD = 'Month';

export const getTableActionStop = (onClick: (data: IMaster) => void) => ({
  name: keyMap.sharedActionsStop,
  onClick,
  isHidden: (data: IMaster) => !data.isCopied,
  iconClass: <XIcon size={16} />,
  className: actionStyles.stopCopyButton,
});

export const getTableActionCopy = (onClick: (data: IMaster) => void) => ({
  name: keyMap.sharedActionsCopy,
  onClick,
  iconClass: <CopyIcon size={16} />,
});
